import { ReactNode } from 'react';
import { TypographyStyled, ButtonStyled } from './styled';

type ButtonImageProps = {
  srcImage?: string;
  onClick: () => void;
  children?: ReactNode;
};

export const ButtonImage = ({ onClick, children, srcImage, ...otherProps }: ButtonImageProps) => {
  return (
    <>
      <ButtonStyled
        fullWidth
        variant="image"
        onClick={onClick}
        srcImage={srcImage}
        {...otherProps}
      />
      <TypographyStyled variant="bodyLargeRegular">{children}</TypographyStyled>
    </>
  );
};
